import { render } from "./Product.vue?vue&type=template&id=5e283896&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=5e283896&lang=css"
import "./Product.vue?vue&type=style&index=1&id=5e283896&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e283896"]])

export default __exports__